import { Scissors, Flame, Crown, ArrowUpRight } from "lucide-react";
import Reveal, { SectionHeader } from "@/components/Reveal";
import { waLink } from "@/lib/site";

const CATEGORIES = [
    {
        icon: Scissors,
        title: "Cortes & Cabelo",
        items: [
            {
                name: "Corte Social Premium",
                price: "R$ 65,00",
                desc: "Lavagem com shampoo especial, corte sob medida e finalização com pomada importada.",
            },
            {
                name: "Corte Degradê / Fade Nobre",
                price: "R$ 75,00",
                desc: "Técnica de transição perfeita, acabamento na navalha e hidratação rápida.",
            },
            {
                name: "Camuflagem de Grisalhos",
                price: "R$ 60,00",
                desc: "Tonalização discreta para harmonizar e rejuvenescer os fios brancos.",
            },
        ],
    },
    {
        icon: Flame,
        title: "Barba & Rosto",
        items: [
            {
                name: "Barboterapia Nobre",
                price: "R$ 55,00",
                desc: "Toalha quente com óleos essenciais, massagem facial e alinhamento com navalhete.",
            },
            {
                name: "Modelagem de Barba",
                price: "R$ 45,00",
                desc: "Desenho preciso da barba, ajuste de volume e hidratação com balm artesanal.",
            },
            {
                name: "Limpeza de Pele Express",
                price: "R$ 50,00",
                desc: "Esfoliação revitalizante, máscara negra para cravos e tonificação facial.",
            },
        ],
    },
    {
        icon: Crown,
        title: "Combos Exclusivos",
        featured: true,
        items: [
            {
                name: "Combo Imperador (Corte + Barba)",
                price: "R$ 110,00",
                desc: "Corte completo + Barboterapia com toalha quente + bebida cortesia do nosso bar.",
                badge: "Mais pedido",
            },
            {
                name: "Combo Dia do Noivo / VIP",
                price: "R$ 220,00",
                desc: "Corte, barba, limpeza facial, sobrancelha, massagem relaxante e bebida premium.",
            },
        ],
    },
];

export default function Services() {
    return (
        <section id="servicos" data-testid="services-section" className="relative py-20 sm:py-28 lg:py-32">
            <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
                <SectionHeader
                    eyebrow="Serviços & Preços"
                    title="O Menu do Cavalheiro"
                    subtitle="Cada serviço é executado como um ritual — com produtos premium, técnicos especializados e atenção absoluta aos detalhes."
                />

                <div className="mt-14 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
                    {CATEGORIES.map((cat, ci) => (
                        <Reveal
                            key={cat.title}
                            delay={ci * 0.12}
                            className={`h-full ${cat.featured ? "lg:-mt-4" : ""}`}
                        >
                            <div
                                data-testid="service-item-card"
                                className={`relative h-full rounded-2xl p-7 sm:p-8 bg-card border transition-all duration-300 hover:-translate-y-1.5 ${
                                    cat.featured
                                        ? "border-gold/45 shadow-[0_20px_60px_rgba(212,175,55,0.08)]"
                                        : "border-white/8 hover:border-gold/50"
                                }`}
                            >
                                {cat.featured && (
                                    <span className="absolute -top-3 left-7 bg-gold-gradient text-obsidian text-[10px] font-bold uppercase tracking-[0.18em] px-3.5 py-1.5 rounded-full">
                                        Mais pedido
                                    </span>
                                )}
                                <div className="flex items-center gap-4 mb-6">
                                    <span className="flex items-center justify-center w-11 h-11 rounded-xl border border-gold/35 text-gold">
                                        <cat.icon size={20} />
                                    </span>
                                    <h3 className="font-display font-bold uppercase text-lg sm:text-xl tracking-wide text-white">
                                        {cat.title}
                                    </h3>
                                </div>

                                <div>
                                    {cat.items.map((item) => (
                                        <div
                                            key={item.name}
                                            className="group py-4 border-b border-white/5 last:border-0 flex items-start justify-between gap-4"
                                        >
                                            <div className="min-w-0">
                                                <h4 className="font-semibold text-[15px] text-cream group-hover:text-gold transition-colors duration-300">
                                                    {item.name}
                                                </h4>
                                                <p className="mt-1.5 text-[13px] leading-relaxed text-cream/55">
                                                    {item.desc}
                                                </p>
                                            </div>
                                            <div className="shrink-0 flex flex-col items-end gap-1.5">
                                                <span className="font-mono font-semibold text-gold text-lg whitespace-nowrap">
                                                    {item.price}
                                                </span>
                                                <a
                                                    href={waLink(
                                                        `Olá! Gostaria de agendar: ${item.name} (${item.price}) na Corte Nobre.`,
                                                    )}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    data-testid="service-book-btn"
                                                    className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.2em] text-gold/60 hover:text-gold transition-colors"
                                                >
                                                    Agendar
                                                    <ArrowUpRight size={12} />
                                                </a>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1} className="mt-8">
                    <p className="text-center text-xs text-cream/40 font-mono tracking-wider">
                        Preços fictícios para demonstração · Pagamento: dinheiro, Pix e cartão
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
